import { render, staticRenderFns } from "./stateMent.vue?vue&type=template&id=ea5a0e90&scoped=true&"
import script from "./stateMent.vue?vue&type=script&lang=js&"
export * from "./stateMent.vue?vue&type=script&lang=js&"
import style0 from "./stateMent.vue?vue&type=style&index=0&id=ea5a0e90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea5a0e90",
  null
  
)

export default component.exports